import React from 'react'
import { PanelBar, PanelBarItem } from '@progress/kendo-react-layout'
import { CheckBox } from '@/components/CheckBox'
import Resx from '@/components/Resx'
import { localized } from '@/decorators/localized'
import { DropDownList } from '@/components/dropDownList'

@localized()
class ReportTemplateSelectorContent extends React.Component {
  reportOnChange (items) {
    if (typeof this.props.onChange === 'function') { this.props.onChange(items) }
  }
  onChange (checked, template) {
    let items = this.props.selectedTemplates.filter(x => x.reportTemplateId !== template.reportTemplateId)
    if (checked) {
      items.push(template)
    }
    this.reportOnChange(items)
  }
  onSelectAllChange (checked, category) {
    let items = [...this.props.selectedTemplates]
    category.templates.forEach(template => {
      if (checked) {
        if (!this.isSelected(template)) { items.push(template) }
      } else {
        if (this.isSelected(template)) { items = items.filter(x => x.reportTemplateId !== template.reportTemplateId) }
      }
    })
    this.reportOnChange(items)
  }
  isSelected (template) {
    if (this.props.selectedTemplates) {
      return this.props.selectedTemplates.find(x => x.reportTemplateId === template.reportTemplateId) !== undefined
    }
    return false
  }
  renderSelectAllCheckBox (category) {
    const isChecked = (category.templates.find(x => !this.isSelected(x)) === undefined)
    return <CheckBox id={`select_all_${category.id}`} title='Common.SelectAll' checked={isChecked} onChange={checked => this.onSelectAllChange(checked, category)} />
  }
  localizeName (item) {
    return this.props.localizeValue(item.name, item.latinName)
  }
  renderTemplates (category) {
    if (!this.props.readonly) {
      return <React.Fragment>
        <div className='select-all'>{this.renderSelectAllCheckBox(category)}</div>
        {category.templates.map((template, index) => <div key={index} className='report-template-item editable'>
          <CheckBox
            key={index} className='template-selector-checkbox'
            id={`template_${category.id}_${template.id}`}
            label={`${this.localizeName(template)}${template.multipleInstitutions ? ` - ${this.props.localize('Reporting.MultipleInstitutions')}` : ''}`}
            checked={this.isSelected(template)}
            onChange={checked => this.onChange(checked, template)} />
          {this.renderVersionList(template)}
        </div>)}
      </React.Fragment>
    }
    return category.templates.map((template, index) => <div key={index} className='report-template-item'>{this.localizeName(template)} <span>(#{template.version})</span></div>)
  }
  renderVersionList (template) {
    const selected = this.props.selectedTemplates.find(x => x.reportTemplateId === template.reportTemplateId)
    if (selected) {
      return <DropDownList
        allowClear={false}
        value={{ id: selected.id, name: `${selected.version}` }}
        valueField='id'
        textField='version'
        clientSide
        dataSource={template.versions}
        // dataSource={(req, options) => context.api.reportTemplateService.getVersions(template.reportTemplateId, selected.id, { ...req, sort: null }, options)}
        onChange={x => x.item && this.onChange(true, { ...template, id: x.item.id, version: parseInt(x.item.version, 10) })}
      />
    }
    // not selected template
    return <React.Fragment />
  }
  renderCategories (categories) {
    if (categories.length === 0) { return <Resx name='Reporting.NoTemplates' /> }
    return (
      <PanelBar>
        {categories.map((item, index) => {
          const numberOfSelectedItems = item.templates.reduce((total, template) => total + (this.isSelected(template) ? 1 : 0), 0)
          const title = (<React.Fragment><span className='title'>{this.localizeName(item)}</span><span className='count'>{numberOfSelectedItems}/{item.totalCount}</span></React.Fragment>)
          return <PanelBarItem key={index} title={title}>{this.renderTemplates(item)}</PanelBarItem>
        })}
      </PanelBar>
    )
  }
  render () {
    const { items, readonly, selectedTemplates = [] } = this.props

    let itemsToDisplay = items.map(item => ({ ...item, totalCount: item.templates.length }))
    if (readonly) {
      // in readonly mode display only those categories, that have at least one selected template
      itemsToDisplay = []
      items.forEach(item => {
        const category = {
          ...item,
          templates: item.templates
            .map(t => {
              const selected = selectedTemplates.find(x => x.reportTemplateId === t.reportTemplateId)
              return (selected ? { ...t, id: selected.id, version: selected.version } : null)
            })
            .filter(x => x !== null),
          totalCount: item.templates.length
        }
        if (category.templates.length > 0) { itemsToDisplay.push(category) }
      })
    }
    return (
      <div className='ReportTemplateSelectorContent'>
        {this.renderCategories(itemsToDisplay)}
      </div>
    )
  }
}

export default ReportTemplateSelectorContent



// WEBPACK FOOTER //
// ./src/components/reporting/reportTemplateSelector/content.js